import { DEFAULT_LOCALE, LANGUAGES_WITHOUT_URL_PREFIX, type SupportedLocale } from '@/constants/locales';

// Prepends the locale prefix to a CMS-sourced path when the active locale
// requires one (e.g. /electricidad/... → /es/electricidad/...). Returns the
// path unchanged for the default locale, for absolute URLs, hashes/mailto/tel,
// or for paths already prefixed with the locale.
export function localizeHref(
  rawHref: string | undefined,
  locale: SupportedLocale | string = DEFAULT_LOCALE
): string | undefined {
  if (!rawHref) return rawHref;
  if (LANGUAGES_WITHOUT_URL_PREFIX.includes(locale)) return rawHref;
  if (!rawHref.startsWith('/')) return rawHref;
  const prefix = `/${locale}`;
  if (rawHref === prefix || rawHref.startsWith(`${prefix}/`)) return rawHref;
  return `${prefix}${rawHref}`;
}
